import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { EnumeratorModel } from '../models/enumerator.model';

export class EnumeratorsApiService extends ApiService {
  static endpoint = 'enumerators';

  /**
   * @param {String} currencyId
   * @param {builderCallback|null} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<EnumeratorModel>>}
   * @public
   */
  static get(builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildUrl(), {
      ...config,
      dataModel: EnumeratorModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
